import { useEffect, useRef } from "react";

const CALENDLY_URL = "https://calendly.com/kavionglobal-info/30min";

export default function CalendlyEmbed() {
  const ref = useRef(null);

  useEffect(() => {
    // Load Calendly widget script once
    const id = "calendly-widget-script";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = "https://assets.calendly.com/assets/external/widget.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  return (
    <div
      ref={ref}
      data-testid="calendly-embed"
      className="calendly-inline-widget rounded-3xl overflow-hidden border border-white/10 bg-[#0A0A0C]"
      data-url={`${CALENDLY_URL}?hide_landing_page_details=1&hide_gdpr_banner=1&background_color=0a0a0c&text_color=ffffff&primary_color=3b82f6`}
      style={{ minWidth: "320px", height: "720px" }}
    />
  );
}

export { CALENDLY_URL };
